import { useContext } from 'react';
import ParentModelContext from '~/context/new-cars/ParentModelContext';
import useEffectiveMake from './useEffectiveMake';

const RAM_TRUCK_MODELS_WITH_PARENT_DISPLAY = ['1500', '2500', '3500'];

export default function useEffectiveModel(
  conditionallyIncludeMake = false
): string {
  const { customizeOptions, trims, truckBodyStyles } =
    useContext(ParentModelContext);
  const make = useEffectiveMake();

  const customizedTrim = customizeOptions.data;
  const truckBodyStyleData = truckBodyStyles.data;
  const model =
    customizedTrim.model || truckBodyStyleData.model || trims.data.model;
  const ramTruckDisplayModel =
    customizedTrim.parentModel ||
    truckBodyStyleData.parentModel ||
    trims.data.parentModel ||
    model;
  const isRamTruck =
    make === 'Ram' &&
    RAM_TRUCK_MODELS_WITH_PARENT_DISPLAY.some(
      variant => model?.includes(variant)
    );

  return isRamTruck
    ? `${conditionallyIncludeMake ? make : ''} ${ramTruckDisplayModel}`.trim()
    : model;
}
